module.exports = __webpack_public_path__ + "img/logo-grad-ruby.dfc555f7.svg";